import { EducatorPageChrome } from "@/pages/educators/page-chrome"
import { useId } from "react"

import { CardContent } from "@/components/ui/card"
import { PageBody } from "@/components/ui/layout"
import { SaveButton } from "@/components/shared/action-buttons"

import Form, { DetailsSection } from "./form"
import { useNavigate } from "@/lib/page-rendering"

export default function Edit() {
  const navigate = useNavigate()
  const id = useId()

  const onSubmit = (data: any) => {
    navigate({
      href: ".",
      method: "patch",
      data: data,
    })
  }

  return (
    <>
      <EducatorPageChrome action={<SaveButton form={id} />} />
      <PageBody>
        <CardContent>
          <Form onSubmit={onSubmit} id={id}>
            <DetailsSection />
          </Form>
        </CardContent>
      </PageBody>
    </>
  )
}
